export const routes = {
  path: {
    home: '/',
    catalog: '/catalog',
    events: '/events',
    eventBooking: '/eventBooking',
    legalNotice: '/legal-notice',
    privacyPolicy: '/privacy-policy',
    myevents: '/myevents',
    generalinfo: '/generalinfo',
    signup: '/signup',
    verify: '/signup/verify',
    login: '/login',
    mailConfirmation: '/login/:confirmationCode/:email?',
    mailLogin: '/login/:email?',
    forgotPass: '/forgotPass',
    resetPass: '/resetPass/:confirmationCode/:email',
    eventDetails: '/eventDetails/:id',
    courseDetails: '/courseDetails/:id',
    learningPathDetails: '/learningPathDetails/:id',
    register: '/register',
    myarea: '/myarea',
    teamArea: '/teamArea',
    myProfile: '/my-profile',
    trainerArea: '/trainerArea',
    iltSessionDetails: '/iltSessionDetails/:id',
    locationArea: '/locationArea',
    termsAndConditions: '/terms-and-conditions',
    bookingConfirmation: '/bookingConfirmation',
    participantConfirmation: '/participantConfirmation',
    publicProperties: '/properties/public',
    catalogVisibility: '/properties/mea-catalog-visibility ',
    consents: '/consents',
    allNews: '/all-news',
    notFound: '/not-found'
  },
  name: {
    home: '/home',
    catalog: '/catalog',
    events: '/events',
    eventBooking: '/eventBooking',
    myevents: '/myevents',
    generalinfo: '/generalinfo',
    signup: '/signup',
    verify: '/signup/verify/',
    login: '/login',
    confirm: '/signup/',
    mailConfirmation: '/login/',
    mailLogin: '/login/',
    forgotPass: '/forgotPass',
    resetPass: '/resetPass/',
    eventDetails: '/eventDetails',
    courseDetails: '/courseDetails',
    learningPathDetails: '/learningPathDetails',
    register: '/register',
    myarea: '/myarea',
    teamArea: '/teamArea',
    trainerArea: '/trainerArea',
    iltSessionDetails: '/iltSessionDetails',
    locationArea: '/locationArea',
    termsAndConditions: '/terms-and-conditions'
  }
};
